const { useEffect } = require("react");

const useScrollToBottom = (element) => {
  useEffect(() => element?.scrollIntoView({ behavior: "smooth" }), [element]);
};

module.exports = { useScrollToBottom };
